<template>
  <div id="configuration-manage" v-if="configuration">
    <div class="route">Konfiguracija</div>
    <div>
      <div>
        <label>Zaključane prijave za dolazak:</label>
        <input type="checkbox" v-model="configuration.areArrivalTimeSlotsLocked" />
      </div>
    </div>
    <button v-on:click="apply">Apply</button>
  </div>
</template>

<script>
export default {
  name: 'Configuration',
  data() {
    return {
      configuration: null,
    };
  },
  mounted() {
    this.$axios.get(`${this.$API_URL}/application-configuration`).then(response => {
      this.configuration = response.data;
    });
  },
  methods: {
    apply: function () {
      this.$axios.put(`${this.$API_URL}/application-configuration`, this.configuration).then(response => {
        if (response.status === 200) window.alert('Uspijesno postavljeno');
      });
    },
  },
};
</script>

<style scoped>
#configuration-manage {
  color: white;
}
</style>